import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Divider, Grid, Slide } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import {
    DebFormListener,
    DebFormMultiSelect,
    DebFormSelect,
} from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "notistack";
import { company } from "../../services/companies";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { providersValidationSchema } from "../../schemas/mobile-providers";
import { provider } from "../../services/mobile-providers";
import { useCallback } from "react";
import { 
    EMAILmovistar, 
    EMAILsmtp, 
    EMAILtelefonica, 
    SMSbitsense, 
    SMSc3ntro, 
    SMSdavivienda, 
    SMSmobisa, 
    SMSmovistar, 
    SMSsupervielle, 
    SMStelefonica, 
    SMStwilio, 
    WHATSAPPvonage, 
    channelTypes, 
    cleanInitialProvider,
    newProvider, 
    providerCompaniesPerType,
    providerConstants} from "../../constants/mobile-providers";

//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });




const MobileProviders = () => {
     // MODAL DE EDICIÓN / CREACIÓN
     const [modalState, setModalState] = useState(false);
     const [modalInitialValues, setModalInitialValues] = useState(
         newProvider
     );
     const [providers, setProviders] = useState([]);
     const [companies, setCompanies] = useState([]);
     const [modalProvidersPerChannel, setModalProvidersPerChannel] = useState([]);
     const [selectedProvider, setSelectedProvider] = useState("");
 
     const getProviders = async () => {
         setProviders(await provider.getAll());
     };
     const getCompanies = async () => {
         setCompanies(await company.getAll());
     };
 
     useEffect(() => {
         getProviders();
         getCompanies();
     }, []);
 
     const { enqueueSnackbar } = useSnackbar();
 
     const handleSubmit = async (values) => {
        //Armado del objeto que contiene unicamente las propiedades especificas del canal y proveedor seleccionados
        const builderProvider = values.provider.split(".")[1];
        const builderChannel = values.channel.split("_")[0]; //Las variables SMS y SMS_REMINDER estan unificadas
        const builderCondition = builderChannel.concat(builderProvider);
        const filteredProperties = Object.entries(values)
        .filter(([key]) => (values.id ? key === "id" : false) || key === "channel" || key === "provider" || key === "providerCompanies" || key.includes(builderCondition))
        .reduce((obj, [key, value]) => {
            obj[key] = value;
            return obj;
        }, {});

         try {
             if (values.id) {
                 //estamos editando
                 const res = await provider.update(filteredProperties);
                 enqueueSnackbar("Proveedor editado", {
                     preventDuplicate: true,
                     variant: "success",
                 });
             } else {
                 const res = await provider.create(filteredProperties);
                 enqueueSnackbar("Proveedor creado", {
                     preventDuplicate: true,
                     variant: "success",
                 });
             }
             closeModal();
             getProviders();
         } catch (error) {
             if (values.id) {
                 enqueueSnackbar("Ocurrió un error al editar el proveedor", {
                     preventDuplicate: true,
                     variant: "error",
                 });
             } else {
                 enqueueSnackbar("Ocurrió un error al crear el proveedor", {
                     preventDuplicate: true,
                     variant: "error",
                 });
             }
         }
     };
 
     const openModal = () => {
         setModalState(true);
     };
 
     const closeModal = () => {
         setModalState(false);
         setModalInitialValues(newProvider);
     };
 
     const handleEdit = (provider) => {
         setModalInitialValues(provider);
         openModal();
     };
     const handleCreateProvider = () => {
         setModalInitialValues(newProvider);
         openModal();
     };
 
       // ALERT DE ELIMINACIÓN
         const [selectedDelete, setSelectedDelete] = useState();
         const [openAlert, setOpenAlert] = useState(false);
         const handleAlertClose = () => {
             setOpenAlert(false);
         };
         const handleAlertOpen = (selectedProvider) => {
             setSelectedDelete(selectedProvider);
             setOpenAlert(true);
         };
 
     const handleDelete = async () => {
         try {
             const res = await provider.delete(
                 selectedDelete.id
             );
             enqueueSnackbar(
                 "Se eliminó el proveedor",
                 {
                     preventDuplicate: true,
                     variant: "success",
                 }
             );
             handleAlertClose();
             getProviders();
         } catch (error) {
             enqueueSnackbar("Ocurrió un error eliminando el proveedor", {
                 preventDuplicate: true,
                 variant: "error",
             });
         }
     };

    //FUNCION QUE MUTA EL MODAL
     const handleFormChange = useCallback(
        (values) => {
            //AL CREAR PROVEEDOR
            if (!provider){
            //ESTADO DEL MODAL DE PROPIEDADES
            setSelectedProvider(values.provider);

            const selectedChannel = values.channel
            //limpiamos el proveedor al cambiar de canal            
            if (!providerCompaniesPerType[selectedChannel]?.some(option => option.value === values.provider)) {
                values.provider = "";
                setSelectedProvider(null);
                setModalInitialValues(values);
            };

        } else {
            //AL EDITAR PROVEEDOR
            const selectedID = values.id
            const selectedChannel = values.channel
            const selectedInnerProvider = values.provider
            const selectedCompanies = values.providerCompanies

            //ESTADO DEL MODAL DE PROPIEDADES
            setSelectedProvider(selectedInnerProvider)

            //AL CAMBIAR DE CANAL
                //LIMPIA PROVIDER Y RESTO DE VARIABLES
                const providerChannel = values.provider.split(".")[0];
                if(providerChannel !== selectedChannel){
                    if (!providerCompaniesPerType[selectedChannel]?.some(option => option.value === values.provider)) {
                        setSelectedProvider(null);
                        //Se deben mantener todas las variables para mantener el estado 
                        //controlado (React), previo a la eleccion de nuevo proveedor.
                        values = {
                            id: selectedID,
                            channel: selectedChannel,
                            provider: "",
                            providerCompanies: selectedCompanies,
                            ...cleanInitialProvider
                        }
                        setModalInitialValues(values);
                    };
                };
            
            //PROVEE NUEVA LISTA DE PROVEEDORES AL SELECT
            switch (selectedChannel) {
                case channelTypes.EMAIL:
                    setModalProvidersPerChannel(providerCompaniesPerType.EMAIL);
                    //En caso de solo existir uno, se autoselecciona
                    if (providerCompaniesPerType.EMAIL.length === 1){
                        setSelectedProvider(providerCompaniesPerType.EMAIL[0].value)
                        values.provider = providerCompaniesPerType.EMAIL[0].value
                    };
                    setModalInitialValues(values);
                    break;

                case channelTypes.SMS:
                    setModalProvidersPerChannel(providerCompaniesPerType.SMS);
                    if (providerCompaniesPerType.SMS.length === 1){
                        setSelectedProvider(providerCompaniesPerType.SMS[0].value)
                        values.provider = providerCompaniesPerType.SMS[0].value
                    };
                    setModalInitialValues(values);
                    break;

                case channelTypes.SMS_REMINDER:
                    setModalProvidersPerChannel(providerCompaniesPerType.SMS_REMINDER);
                    if (providerCompaniesPerType.SMS_REMINDER.length === 1){
                        setSelectedProvider(providerCompaniesPerType.SMS_REMINDER[0].value)
                        values.provider = providerCompaniesPerType.SMS_REMINDER[0].value
                    };
                    setModalInitialValues(values);
                    break;

                case channelTypes.WHATSAPP:
                    setModalProvidersPerChannel(providerCompaniesPerType.WHATSAPP);
                    if (providerCompaniesPerType.WHATSAPP.length === 1){
                        setSelectedProvider(providerCompaniesPerType.WHATSAPP[0].value)
                        values.provider = providerCompaniesPerType.WHATSAPP[0].value
                    };
                    setModalInitialValues(values);
                    break;

                default:
                    
            };
            
        }
    }    
        
        
        ,[]);
 
     return (
         <Box>
             <Header
                 title="PROVEEDORES"
             />
             <DataTable
                 loading={!providers.length}
                 rows={providers}
                 columns={[
                     { field: "id", headerName: "ID", flex: 0.1 },
                     {
                         field: "channel",
                         headerName: "Canal",
                         flex: 0.6
                     },
                     {
                         field: "provider",
                         headerName: "Proveedor",
                         flex: 0.6
                     },
                     {
                         field: "providerCompanies",
                         headerName: "Compañías usando el proveedor",
                         flex: 1,                        
                         renderCell: (params) => {
                            return params?.row?.providerCompanies.length;
                         },
                     },
                 ]}
                 rowActions={[
                     {
                         label: "Editar",
                         icon: <EditIcon />,
                         action: handleEdit,
                     },
                     {
                         label: "Eliminar",
                         icon: <DeleteIcon />,
                         action: handleAlertOpen
                     },
                 ]}
                 headerActions={[
                     {
                         label: "Crear Proveedor",
                         icon: <AddBoxIcon />,
                         action: handleCreateProvider,
                     },
                 ]}
             />
 
             {/* MODAL DE CREACIÓN / EDICIÓN DE CONEXIÓN MÓBIL */}
             <DebFormModal
                 maxWidth="md"
                 fullWidth={true}
                 open={modalState}
                 onClose={closeModal}
                 onReject={closeModal}
                 initialValues={modalInitialValues}
                 onSubmit={handleSubmit}
                 formikProps={{
                     enableReinitialize: true,
                     validationSchema: providersValidationSchema,
                 }}
                 headerText={
                     modalInitialValues?.id
                         ? "Editar Proveedor"
                         : "Crear Proveedor"
                 }>
                     <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <DebFormSelect
                                label={"Canal"}
                                name={"channel"}
                                selectOptions={[
                                    { label: channelTypes.EMAIL, value: channelTypes.EMAIL },
                                    { label: channelTypes.SMS, value: channelTypes.SMS },
                                    { label: channelTypes.SMS_REMINDER, value: channelTypes.SMS_REMINDER },
                                    { label: channelTypes.WHATSAPP, value: channelTypes.WHATSAPP },
                                ]}
                            />
                         </Grid>
                         <Grid item xs={4}>
                            <DebFormSelect
                                label={"Nombre del Proveedor"}
                                name={"provider"}
                                selectOptions={modalProvidersPerChannel}
                            />
                         </Grid>
                         <Grid item xs={4}>
                            <DebFormMultiSelect
                                label={"Compañías usando el proveedor"}
                                name={"providerCompanies"}
                                selectOptions={Array.from(companies)?.map((company) => {
                                    return {
                                        value: company.id,
                                        label: company.name,
                                    };
                                })}
                            />
                         </Grid>
                        </Grid>
                        <DebFormListener otraCosa={handleFormChange} />
                        
                        {selectedProvider && (
                            
                            <DialogTitle sx={{ fontFamily:'Inter Tight', fontSize: "1.7rem", padding: "0rem 1rem 0rem 1.5rem", fontWeight:"100", textAlign:"center", textTransform: "uppercase"}}>
                                <Divider sx={{mb:3}} />
                                Propiedades                                
                            </DialogTitle>
                        )}
                        {selectedProvider === providerConstants.EMAIL_MOVISTAR && EMAILmovistar}
                        {selectedProvider === providerConstants.EMAIL_SMTP && EMAILsmtp}
                        {selectedProvider === providerConstants.EMAIL_TELEFONICA && EMAILtelefonica}
                        {(selectedProvider === providerConstants.SMS_BITSENSE || selectedProvider === providerConstants.SMS_REMINDER_BITSENSE) && SMSbitsense}
                        {(selectedProvider === providerConstants.SMS_C3NTRO || selectedProvider === providerConstants.SMS_REMINDER_C3NTRO) && SMSc3ntro}
                        {(selectedProvider === providerConstants.SMS_DAVIVIENDA || selectedProvider === providerConstants.SMS_REMINDER_DAVIVIENDA) && SMSdavivienda}
                        {(selectedProvider === providerConstants.SMS_MOBISA || selectedProvider === providerConstants.SMS_REMINDER_MOBISA) && SMSmobisa}
                        {(selectedProvider === providerConstants.SMS_MOVISTAR || selectedProvider === providerConstants.SMS_REMINDER_MOVISTAR) && SMSmovistar}
                        {(selectedProvider === providerConstants.SMS_SUPERVIELLE || selectedProvider === providerConstants.SMS_REMINDER_SUPERVIELLE) && SMSsupervielle}
                        {(selectedProvider === providerConstants.SMS_TELEFONICA || selectedProvider === providerConstants.SMS_REMINDER_TELEFONICA) && SMStelefonica}
                        {(selectedProvider === providerConstants.SMS_TWILIO || selectedProvider === providerConstants.SMS_REMINDER_TWILIO) && SMStwilio}
                        {selectedProvider === providerConstants.WHATSAPP_VONAGE && WHATSAPPvonage}
                        
                        
                     
                     
             </DebFormModal>
 
             {/* ALERT DE ELIMINACIÓN */}
             <Dialog
                 open={openAlert}
                 TransitionComponent={Transition}
                 keepMounted
                 onClose={handleAlertClose}
                 aria-describedby="alert-dialog-slide-description"
             >
                 <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                 <DialogActions>
                 <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                 <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                 </DialogActions>
             </Dialog>
         </Box>
     );
 };
 
export default MobileProviders;
